export const messages_ar = {
    nameEmpty: "لا يمكن أن يكون الاسم فارغًا.",
    emailEmpty: "لا يمكن أن يكون عنوان البريد الإلكتروني فارغًا.",
    emailNotValid: "عنوان البريد الإلكتروني غير صحيح ، يرجى إدخال عنوان البريد الإلكتروني بشكل صحيح.",
    locationEmpty: "لا يمكن أن يكون الموقع فارغًا.",
    interests: "قم بإختيار 3 مجالات إهتمام.",
    profileSaved: "تم حفظ بيانات الملف الشخصي.",
    profilePic: "تم حفظ صورة الملف الشخصي.",
    addToFavorites: "تمت الاضافة بنجاح إلى المفضلة.",
    removeFromFavorites: "تمت الإزالة بنجاح من المفضلة."
};


// WEBPACK FOOTER //
// ./src/constants/messages_ar.js